// stylesheet (bundled by Rsbuild alongside this entry)
import "../stylesheets/site.css"

// hook common components
import Button from "./components/button"
import Map from "./components/map"
import Maplibre from "./components/maplibre"
import Navbar from "./components/navbar"
import Modal from "./components/modal"
import ShareModal from "./components/share-modal"
import ConfirmModal from "./components/confirm-modal"
import ContextMenu from "./components/context-menu"
import TabbedContent from "./components/tabbed-content"
import MenuedContent from "./components/menued-content"
import ExpandableText from "./components/expandable-text"
import Carousel from "./components/carousel"
import CardsCarousel from "./components/cards-carousel"
import FormInput from "./components/form-input"
import FormChoices from "./components/form-choices"
import FormEditorjs from "./components/form-editorjs"
import FormCaptcha from "./components/form-captcha"
import NativeApp from "./components/native-app"
import LocationDebug from "./components/location-debug"
import LocationTracker from "./components/location-tracker"
import { Stops, StopsMap } from "./components/stops"
import Slideshow from "./components/slideshow"
import Hero from "./components/hero"
import SiteSaveModal from "./components/site-save-modal"
import SiteCard from "./components/site-card"

// hook page components
import { ExplorePage } from "./pages/site/explore-page"
import {
  SitePage,
  SitePageReportImagesUpload,
  SitePageReportMap,
} from "./pages/site/site-page"
import { ContentsPage } from "./pages/site/contents-page"
import { GuidePage, GuidePageHeroCategories } from "./pages/site/guide-page"
import { GuidesPage } from "./pages/site/guides-page"
import { RegionsPage } from "./pages/site/regions-page"
import { RegionPage } from "./pages/site/region-page"
import { ListEditPageObjects } from "./pages/site/list-edit-page"
import { TripEditPageObjects } from "./pages/site/trip-edit-page"
import { ProfilePageCollectionMap } from "./pages/site/profile-page"
import { SettingsPagePasskey } from "./pages/site/settings-page"
import { SignPagePasskey, SignPageTotpCodeInput } from "./pages/site/sign-page"

// inits
import initLiveSocket from "./init/livesocket"
import initLoadingBar from "./init/loading-bar"
import initBeforeunload from "./init/beforeunload"
import initAnalytics from "./init/analytics"
import initLinkable from "./init/linkable"
import initCopyable from "./init/copyable"
import initTooltip from "./init/tooltip"
import initFixAchors from "./init/fix-anchors"
import initExploreBounds from "./init/explore-bounds"
import initFallbackFailedImages from "./init/fallback-failed-images"
import initLocationTrackerUpdater from "./init/location-tracker-updater"

const hooks = {
  // components
  Button,
  Map,
  Maplibre,
  Navbar,
  Modal,
  ShareModal,
  ConfirmModal,
  ContextMenu,
  TabbedContent,
  MenuedContent,
  ExpandableText,
  Carousel,
  CardsCarousel,
  FormInput,
  FormChoices,
  FormEditorjs,
  FormCaptcha,
  NativeApp,
  LocationDebug,
  LocationTracker,
  Stops,
  StopsMap,
  Slideshow,
  Hero,
  SiteSaveModal,
  SiteCard,
  // pages
  ExplorePage,
  SitePage,
  SitePageReportImagesUpload,
  SitePageReportMap,
  ContentsPage,
  GuidePage,
  GuidePageHeroCategories,
  GuidesPage,
  RegionsPage,
  RegionPage,
  ListEditPageObjects,
  TripEditPageObjects,
  ProfilePageCollectionMap,
  SettingsPagePasskey,
  SignPagePasskey,
  SignPageTotpCodeInput,
}

initLiveSocket({ hooks })
initLoadingBar()
initBeforeunload()
initAnalytics()
initLinkable()
initCopyable()
initTooltip()
initFixAchors()
initExploreBounds()
initFallbackFailedImages()
initLocationTrackerUpdater()
